<template>
  <v-data-table
    :headers="headers"
    :items="tableData"
    item-key="name"
    hide-actions
    class="elevation-1 custom-data-table"
  >
    <template slot="header" slot-scope="{ header }">
      <tr>
        <th
          v-for="col in headers"
          :key="col.text"
          :style="{ width: col.width }"
        >
          {{ header[col.value] }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left parameter-name">
        {{ $t(props.item.name) }}
        <span class="unit"> ({{ props.item.unit }})</span>
      </td>
      <td class="text-xs-center">
        <span
          :class="
            props.item.today != null &&
            props.item.today != 'No Data' &&
            props.item.today != '-'
              ? 'number--text value'
              : 'error--text no-value'
          "
          >{{ props.item.today == null ? "-" : props.item.today }}</span
        >
      </td>
      <td class="text-xs-center">
        <span
          :class="
            props.item.yesterday != null &&
            props.item.yesterday != 'No Data' &&
            props.item.yesterday != '-'
              ? 'number--text value'
              : 'error--text no-value'
          "
          >{{ props.item.yesterday == null ? "-" : props.item.yesterday }}</span
        >
      </td>
      <td class="text-xs-center">
        <span
          :class="
            props.item.month != null &&
            props.item.month != 'No Data' &&
            props.item.month != '-'
              ? 'number--text value'
              : 'error--text no-value'
          "
          >{{ props.item.month == null ? "-" : props.item.month }}</span
        >
      </td>
      <td class="text-xs-center">
        <span
          :class="
            props.item.year != null &&
            props.item.year != 'No Data' &&
            props.item.year != '-'
              ? 'number--text value'
              : 'error--text no-value'
          "
          >{{ props.item.year == null ? "-" : props.item.year }}</span
        >
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: function () {
        return [];
      },
    },
    tableData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
};
</script>

<style scoped>
.parameter-name {
  font-size: 14px;
  padding-left: 10px !important;
}
.custom-data-table {
  max-height: 580px;
  overflow-y: auto;
  overflow-y: auto;
  border-radius: 8px !important;
  border: 1px solid #334079;
  font-size: 12px !important ;
}

/* To add vertical lines between columns */
.custom-data-table thead th:not(:last-child),
.custom-data-table tbody td:not(:last-child) {
  border-right: 1px solid #334079;
}

.custom-data-table thead th {
  height: 48px;
  font-size: 14px;
  font-weight: 700 !important;
}

.custom-data-table th {
  z-index: 1;
  position: sticky;
  top: 0;
}

.theme--dark .custom-data-table thead th {
  color: #fff !important;
}

.theme--light .custom-data-table thead th {
  color: #000 !important;
}

.custom-data-table thead th:not(:first-child) {
  padding: 0px !important;
}
</style>